import { LinearProgress } from '@mui/material';
import { DataGridProProps, useGridApiRef } from '@mui/x-data-grid-pro';
import { DataGridPro as DataGrid } from '@mui/x-data-grid-pro/DataGridPro/DataGridPro';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'store/hooks';
import { useAppState } from 'store/Provider';

import { PurchaseOrderFields, useColumns } from './PurchaseOrderTableServices';
import PurchaseOrders from 'types/entities/PurchaseOrders';

const PurchaseOrderTable: React.FC = (purchaseOrder) => {
  const { dispatch } = useAppState();
  const state = useSelector((state) => state.purchaseOrder);
  const [dataList, setDataList] = useState<PurchaseOrders[]>([]);
  const apiRef = useGridApiRef();
  const loadings = useSelector((state) => state.loadings);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    setDataList(state?.datas || []);
  }, [state?.datas]);

  const columns = useColumns(PurchaseOrderFields, 0);
  const dataTableProps: Omit<DataGridProProps, 'columns'> = {
    rows: dataList ?? [],
    apiRef,
    autoHeight: true,
    pagination: false,
    disableColumnMenu: true,
    headerHeight: 100,
    rowHeight: 80,
    sortingMode: 'server',
    keepNonExistentRowsSelected: true,
    disableSelectionOnClick: true,
    checkboxSelection: false, // TODO ignore unselect or select after a select all
  };

  useEffect(() => {
    setIsLoading(((loadings?.table ?? 0) > 0 && (loadings?.api ?? 0) > 0) || (loadings?.purchaseorderlist ?? 0) > 0);
  }, [isLoading, loadings?.api, loadings?.table, loadings?.purchaseorderlist]);

  const [filterButtonEl, setFilterButtonEl] = React.useState<HTMLButtonElement | null>(null);
  return (
    <>
      <div>
        <DataGrid
          columns={columns.purchaseOrder}
          components={{
            // Toolbar: CustomToolbar,
            LoadingOverlay: LinearProgress,
          }}
          componentsProps={{
            loadingOverlay: { style: { zIndex: 9999 } },
            panel: {
              anchorEl: filterButtonEl,
              placement: 'bottom-end',
            },
            toolbar: {
              setFilterButtonEl,
            },
          }}
          loading={isLoading}
          //   className={state.selectedAllVideos ? 'test' : ''}
          {...dataTableProps}
          sx={{
            '& .Mui-disabled': {
              background: '#e1e5ef',
              opacity: '.9',
              pointerEvents: 'initial',
            },
            overflow: 'auto',
            mb: { xs: 30, md: 10 },
            '& .MuiDataGrid-columnHeaderCheckbox .MuiDataGrid-columnHeaderTitleContainer': {
              display: 'none',
            },
          }}
        />
      </div>
    </>
  );
};

export default PurchaseOrderTable;
